import { useState } from 'react';
import { PasskeysQueryKeys } from '../../queryKey';
import { PaginatedRequest } from '@/models/pagination/paginated-request';
import { UsePasskeysQueryKeyProps } from './props';
import { useQuery } from '@tanstack/react-query';
import { fetchPasskeys } from './service';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { usePaginatedQuery } from '@starsoft/common/hooks';
import { UserPasskey } from '@/models/user-passkey';

export function usePasskeys() {
  const [page, setPage] = useState(1);

  const filter: PaginatedRequest = {
    page,
    limit: 8,
  };
  const queryKey: UsePasskeysQueryKeyProps = [
    PasskeysQueryKeys.Passkey,
    filter,
  ];

  const { data, isPending, error, refetch } = useQuery<
    PaginatedResponse<UserPasskey>,
    AxiosError<GenericError>,
    PaginatedResponse<UserPasskey>,
    UsePasskeysQueryKeyProps
  >({ queryKey, queryFn: fetchPasskeys });

  const { fetchNextPage, fetchPreviousPage, setCurrentPage } =
    usePaginatedQuery({
      data,
      page,
      setPage,
    });

  return {
    page,
    error,
    refetch,
    isPending,
    fetchNextPage,
    setCurrentPage,
    fetchPreviousPage,
    passkeys: data,
  };
}
